import { render, staticRenderFns } from "./EditarAcompanhamentoDeTurmasProfessor.vue?vue&type=template&id=0a63d180"
import script from "./EditarAcompanhamentoDeTurmasProfessor.vue?vue&type=script&lang=js"
export * from "./EditarAcompanhamentoDeTurmasProfessor.vue?vue&type=script&lang=js"
import style0 from "./EditarAcompanhamentoDeTurmasProfessor.vue?vue&type=style&index=0&id=0a63d180&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports